var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account circle",
    clipPath: "url(#clip0_1942_838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0.5C8.96 0.5 0 9.46 0 20.5C0 31.54 8.96 40.5 20 40.5C31.04 40.5 40 31.54 40 20.5C40 9.46 31.04 0.5 20 0.5ZM20 8.5C23.86 8.5 27 11.64 27 15.5C27 19.36 23.86 22.5 20 22.5C16.14 22.5 13 19.36 13 15.5C13 11.64 16.14 8.5 20 8.5ZM20 36.5C15.94 36.5 11.14 34.86 7.72 30.74C11.1 28.1 15.36 26.5 20 26.5C24.64 26.5 28.9 28.1 32.28 30.74C28.86 34.86 24.06 36.5 20 36.5Z",
    fill: "#DBDBDB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1942_838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountcircle);
export default __webpack_public_path__ + "static/media/Account circle.dbcfcb32733d640d2c39d5317472c365.svg";
export { ForwardRef as ReactComponent };